import {ColumnMain} from "../column-main";
import {Column} from "../column";
import {Trans} from "@lingui/macro";
import React from "react";
import { Tag } from "antd";

const StockListModel = () : ColumnMain => {

    const columns : Array<Column> = new Array();
    columns.push({
        key:'rollNumber', filter:true, width: 150, fixed: "left", sorter:true,title:<Trans>Roll Number</Trans>,
        render: (text, row, index) => {

            let color = 'default';

            switch(row['status']) {
                case 'CAN_BE_USED':
                case 'TAKEN_BACK_FROM_PRODUCTION':
                    color = 'white';
                    break;
                case 'PRODUCED':
                    color = '#b7eb8f';
                    break;
                case 'LOCKED':
                    color = 'gold';
                    break;
                case 'SCRAP':
                    color = '#ffa39e';
                    break;
            }
            return { props: { style: {background: color} }, children: <>{text}</> };
        }
    });
    columns.push({key:'deliveryNoteNumber', filter:true, width: 200, sorter:true,title:<Trans>Delivery Note Number</Trans>});
    columns.push({key:'item.fifoNumber', width: 200, dataIndex: ['item', 'fifoNumber'], filter:true, sorter:true,title:<Trans>Fifo number</Trans>});
    columns.push({key:'supplier.name', width: 200, dataIndex: ['supplier', 'name'], filter:true, sorter:true,title:<Trans>Supplier</Trans>});
    columns.push({key:'weight', width: 150, filter:true, sorter:true,title:<Trans>Weight</Trans>});
    columns.push({
        key:'status',
        width: 200,
        sorter:true,
        title:<Trans>Status</Trans>,
        uniqueSelectFilterData: [
            { label: <Trans>All</Trans>, value: null },
            { label: <Trans>Manufactured</Trans>, value: 'PRODUCED' },
            { label: <Trans>Usable</Trans>, value: 'CAN_BE_USED' },
            { label: <Trans>Locked</Trans>, value: 'LOCKED' },
            { label: <Trans>Scrap</Trans>, value: 'SCRAP' },
            { label: <Trans>Returned from production</Trans>, value: 'TAKEN_BACK_FROM_PRODUCTION' },
        ],
        render: (status: string) => {
            let color = 'default';
            let label: React.ReactNode = status;

            switch(status) {
                case 'PRODUCED':
                    color = 'green';
                    label = <Trans>Manufactured</Trans>;
                    break;
                case 'CAN_BE_USED':
                    color = 'blue';
                    label = <Trans>Usable</Trans>;
                    break;
                case 'LOCKED':
                    color = 'gold';
                    label = <Trans>Locked</Trans>;
                    break;
                case 'SCRAP':
                    color = 'red';
                    label = <Trans>Scrap</Trans>;
                    break;
                case 'TAKEN_BACK_FROM_PRODUCTION':
                    color = 'blue';
                    label = <Trans>Returned from production</Trans>;
                    break;
            }

            return <Tag color={color}>{label}</Tag>;
        }
    });
    columns.push({key:'remark', width: 150, filter:true, sorter:true,title:<Trans>Remark</Trans>});
    columns.push({key:'updatedDate', width: 150, dateFilter:true, direction: "desc", sorter:true,title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 150, dateFilter:true, sorter:true,title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 150, dateFilter:true, sorter:true,title:<Trans>Created Date</Trans>});
    columns.push({key:'createdBy', width: 150, dateFilter:true, sorter:true,title:<Trans>Created By</Trans>});

    return{
        columns:columns,
        url:"/resource/stock"
    };

}
export default StockListModel();
